import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const SidebarDistributionLineAreaMasterTableDataAPI = createAsyncThunk("SidebarDistributionLineAreaMasterTableData", async ({ data }) => {
    const {
        M_Distri_WS_LocationID,
        token,
        From,
        To,
        M_UsersID
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_Distri_WS_AreaDetails_Select?M_Distri_WS_LocationID=${M_Distri_WS_LocationID ? M_Distri_WS_LocationID : '0'}&M_UserID=${M_UsersID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const SidebarDistributionLineAreaMasterTableDataSlice = createSlice({
    name: "SidebarDistributionLineAreaMasterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SidebarDistributionLineAreaMasterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(SidebarDistributionLineAreaMasterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(SidebarDistributionLineAreaMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const SidebarDistributionLineAreaMasterTableDataReducer = SidebarDistributionLineAreaMasterTableDataSlice.reducer


export const SidebarDistributionLineAreaMasterPostDataAPI = createAsyncThunk("SidebarDistributionLineAreaMasterPostData", async ({ data }) => {
    const {
        M_Distri_WS_AreaDetailsID,
        M_Distri_WS_LocationID,
        AreaDetails,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_Distri_WS_AreaDetailsID", M_Distri_WS_AreaDetailsID);
    formdata.append("M_Distri_WS_LocationID", M_Distri_WS_LocationID);
    formdata.append("AreaDetails", AreaDetails);
    formdata.append("M_UserID",M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_WEB_M_Distri_WS_AreaDetails_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const SidebarDistributionLineAreaMasterPostDataSlice = createSlice({
    name: "SidebarDistributionLineAreaMasterPostData",
    initialState: {
        isPostLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SidebarDistributionLineAreaMasterPostDataAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(SidebarDistributionLineAreaMasterPostDataAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(SidebarDistributionLineAreaMasterPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const SidebarDistributionLineAreaMasterPostDataReducer = SidebarDistributionLineAreaMasterPostDataSlice.reducer

// -----------------Delete API ---------------

export const SidebarDistributionLineAreaMasterDeleteAPI = createAsyncThunk("SidebarDistributionLineAreaMasterDelete", async ({ data }) => {
    const {
        M_Distri_WS_AreaDetailsID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("M_Distri_WS_AreaDetailsID", M_Distri_WS_AreaDetailsID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/WEB_M_Distri_WS_AreaDetails_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const SidebarDistributionLineAreaMasterDeleteSlice = createSlice({
    name: "SidebarDistributionLineAreaMasterDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SidebarDistributionLineAreaMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(SidebarDistributionLineAreaMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(SidebarDistributionLineAreaMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const SidebarDistributionLineAreaMasterDeleteReducer = SidebarDistributionLineAreaMasterDeleteSlice.reducer